// extracted by mini-css-extract-plugin
export default {"detailDrawer":"detailDrawer--kVOb1","descriptionImg":"descriptionImg--RSto_","descriptionContent":"descriptionContent--Vy3rs","markerAnimationScale":"markerAnimationScale--j5iyp"};